<!--  -->
<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  
  data() {
    return {};
  },
  components: {
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang='scss' scoped>

</style>